import type { FC } from 'react';
import { SetWrapper } from './Set.styled';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula } from 'react-syntax-highlighter/dist/esm/styles/prism';

interface SetProps { }

const SetCollection: FC<SetProps> = () => (
  <SetWrapper>
    <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Set</h1>
    </header>
    <br/>
    <div className="entry-content clear" itemProp="text">
      <p className="text-align-justify">Set Interface extends the Collection interface. It represents the unordered set of elements. However, the set doesn’t allow us to store duplicate items. In addition, it can store at most one null value. Set is implemented by HashSet, LinkedHashSet, and TreeSet.</p>
      <br/>
      <h4 className="text-align-justify">Syntax :</h4>
      <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
        {
          'Set s1 = new HashSet();\n'+
          'Set s2 = new LinkedHashSet();\n'+
          'Set s3 = new TreeSet();'
        }
      </SyntaxHighlighter>
      <br/>
      <ul className="text-align-justify">
        <li><strong>HashSet </strong>
          <ul>
            <li>HashSet class implements Set Interface.</li>
            <li>In other words, it represents a collection that uses a hash table for storage.</li>
            <li>It contains unique items.</li>
            <li>Eg :
              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                {
                  'HashSet set = new HashSet();\n'+
                  'set.add(“Ram”);'
                }
              </SyntaxHighlighter>
            </li>
          </ul>
        </li>
        <br/>
        <li><strong>LinkedHashSet </strong>
          <ul>
            <li>LinkedHashSet extends the HashSet class and implements the Set interface.</li>
            <li>It also contains unique elements.</li>
            <li>It permits null elements and maintains the insertion order of elements.</li>
            <li>Eg :
              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                {
                  'LinkedHashSet set = new LinkedHashSet();\n'+
                  'set.add(“Ram”);'
                }
              </SyntaxHighlighter>
            </li>
          </ul>
        </li>
        <br/>
        <li><strong>SortedSet </strong>
          <ul>
            <li>SortedSet is the alternate of the Set interface.</li>
            <li>It represents an ordered list of elements.</li>
            <li>The elements of the SortedSet are arranged in the increasing (ascending) order.</li>
            <li>Eg :
              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                {
                  'SortedSet set = new TreeSet();\n'+
                  'set.add(“Ram”);'
                }
              </SyntaxHighlighter>
            </li>
          </ul>
        </li>
        <br/>
        <li><strong>TreeSet </strong>
          <ul>
            <li>TreeSet class implements the Set interface.</li>
            <li>It contains unique elements.</li>
            <li>It has quite fast access and retrieval time.</li>
            <li>The elements in TreeSet stored in ascending order.</li>
            <li>Eg :
              <SyntaxHighlighter language="java" style={dracula} showLineNumbers={true}>
                {
                  'TreeSet set = new TreeSet();\n'+
                  'set.add(“Ram”);'
                }
              </SyntaxHighlighter>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </SetWrapper>
);

export default SetCollection;
